/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CarouselElementContainer,
  CarouselContainer,
  FlexContainer,
  MobileCarouselElementContainer,
} from './OffersCardsSkeletonLoader.styles';

interface OffersCardsSkeletonLoaderProps {
  isMobileViewPort: boolean;
  model?: any;
}

export const OffersCardsSkeletonLoader: React.FC<OffersCardsSkeletonLoaderProps> = ({ isMobileViewPort, model }) => {
  const totalCards = 4;
  const enableCardElementsLoader = false;
  const shouldShowDetails = model?.subTitleText || model?.titleText;

  const renderCards = () => {
    return Array.from({ length: totalCards }, (_, index) => (
      <div key={index} className="standard-container">
        <div
          className={`skeleton-loader skeleton-loader-composite ${isMobileViewPort ? 'square' : 'wide'} ${
            enableCardElementsLoader && 'skeleton-details'
          }`}
        >
          {enableCardElementsLoader && (
            <div className="skeleton-card-content">
              <div className="skeleton-loader card-eyebrow"></div>
              <div className="skeleton-loader card-text"></div>
            </div>
          )}
        </div>
      </div>
    ));
  };

  return isMobileViewPort ? (
    <CarouselContainer data-testid="carousel-container-skeleton-loader">
      {shouldShowDetails && (
        <FlexContainer>
          <div className="skeleton-loader carousel-heading"></div>
          <div className="skeleton-loader carousel-subheading"></div>
        </FlexContainer>
      )}

      <MobileCarouselElementContainer>{renderCards()}</MobileCarouselElementContainer>
    </CarouselContainer>
  ) : (
    <CarouselContainer data-testid="carousel-container-skeleton-loader">
      {shouldShowDetails && (
        <FlexContainer>
          <div className="skeleton-loader carousel-heading"></div>
          <div className="skeleton-loader carousel-subheading"></div>
        </FlexContainer>
      )}

      <CarouselElementContainer>{renderCards()}</CarouselElementContainer>
    </CarouselContainer>
  );
};
